export const formatNumberWithSpaces = (value, decimalPlaces = 2) => {
	if (!value) return ''
	const stringValue = typeof value === 'string' ? value : String(value)
	const numericValue = stringValue.replace(/[^\d.,]/g, '')

	return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function removeSpaces(value) {
	return String(value)
		.replace(/[^0-9.,]/g, '')
		.replace(/\s+/g, '')
}

export function parseLocalizedNumberInput(rawValue) {
	return parseFloat(removeSpaces(rawValue).replace(',', '.')) || 0
}

// export function numberWithSpaces(number) {
// 	if (number === '' || number === undefined) return ''

// 	let strInput = String(number).replaceAll(',', '.')

// 	const parsingNumber = parseFloat(
// 		strInput.replace(/\s/g, '').replace(',', '.'),
// 	)
// 	if (isNaN(parsingNumber)) {
// 		return number
// 	}

// 	return new Intl.NumberFormat('fr-FR').format(parsingNumber)
// }

export function numberWithSpacesIntl(num, decimals = 2) {
	// Handle invalid inputs
	if (
		(typeof num !== 'number' && typeof num !== 'string') ||
		(typeof num === 'string' && isNaN(parseFloat(num.replace(',', '.')))) ||
		typeof decimals !== 'number' ||
		decimals < 0
	) {
		console.error('numberWithSpacesIntl: Invalid arguments')
		return null
	}

	// Convert input to number, handling both . and , as decimal separators
	let number =
		typeof num === 'string' ? parseFloat(num.replace(',', '.')) : num

	// Calculate truncated value
	const factor = Math.pow(10, decimals)
	const truncated = Math.trunc(number * factor) / factor

	// Split into integer and decimal parts
	const [integerPart, decimalPart] = truncated.toString().split('.')

	// Add space separators to integer part
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

	// Handle decimal part
	if (decimals === 0 || !decimalPart || Number(`0.${decimalPart}`) === 0) {
		return formattedInteger
	}

	// Format with specified decimals and remove trailing zeros
	let result = truncated.toFixed(decimals)
	const finalDecimalPart = result.split('.')[1].replace(/0+$/, '')

	return finalDecimalPart.length > 0
		? `${formattedInteger}.${finalDecimalPart}`
		: formattedInteger
}

// export function numberWithSpacesIntl(input) {
// 	if (input === '' || input === undefined) return ''

// 	const original = String(input).trim()
// 	const hasComma = original.includes(',')
// 	const hasDot = original.includes('.')

// 	const userDecimalSeparator = hasComma && !hasDot ? ',' : '.'

// 	const normalized = original.replace(/\s/g, '').replace(',', '.')

// 	const parsed = parseFloat(normalized)
// 	if (isNaN(parsed)) return original

// 	// Truncate without rounding to 2 decimal places
// 	const truncated = Math.trunc(parsed * 100) / 100
// 	let [intPart, decimalPart = ''] = truncated.toString().split('.')

// 	// Format int part with space separators
// 	intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

// 	// If user provided a decimal separator
// 	if (hasComma || hasDot) {
// 		// Cut to match how much the user actually typed after the separator
// 		const originalDecimal = original.split(/[,.]/)[1] ?? ''
// 		const finalDecimal = decimalPart.slice(0, originalDecimal.length)

// 		if (finalDecimal) {
// 			return `${intPart}${userDecimalSeparator}${finalDecimal}`
// 		} else {
// 			return `${intPart}${userDecimalSeparator}`
// 		}
// 	}

// 	// No decimal originally, return just formatted int
// 	return intPart
// }

export const formatInputNumber = (value) => {
	if (!value) return ''
	const stringValue = typeof value === 'string' ? value : String(value)
	const numericValue = stringValue.replace(/[^\d.,]/g, '')

	return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const roundToTwoDecimals = (num) => ((num * 100 + 0.5) | 0) / 100

export function toFixedTruncate(num, decimals = 2) {
	if (isNaN(num) || typeof decimals !== 'number' || decimals < 0) {
		console.error('toFixedTruncate: Invalid arguments')
	}

	const factor = Math.pow(10, decimals)
	const truncated = Math.trunc(num * factor) / factor

	return truncated.toString()
}
